import React from "react";
import { useSignalR } from "../../../common/helpers/SignalR";
import { UpdatedPropertiesNotification } from "../models/UpdatedPropertiesNotification";

export const useUpdatedPropertiesNotification = (callback: (notification: UpdatedPropertiesNotification) => void, deps: React.DependencyList) => useSignalR<UpdatedPropertiesNotification>("UpdateProperties", callback, deps);
